
$( window ).scroll(function() {
  var scroll = $(window).scrollTop();
  if(scroll >= 150){
    if(!$('.sticky-menu-header').hasClass('top-sticky-menu')){
      $('.sticky-menu-header').addClass('top-sticky-menu');
      $('.when-menu-is-stick').show();
      $('.sticky-menu-header').css('position', 'fixed').css('top', '0').css('z-index', '10002');
      $('.navbar-toolbar').css('background', 'rgba(255, 255, 255, 0.95)');
      //$('.headertop').css('background', 'rgba(255, 255, 255, 0.95)');
      $('.navbar-main.mainmenu').css('background', 'rgba(255, 255, 255, 0.95)');
      $('.navbar-nav.footer-sticky').show();
    }
  } else {
    $('.when-menu-is-stick').hide();
    $('.sticky-menu-header').removeClass('top-sticky-menu');
    $('.sticky-menu-header').css('position', 'relative').css('top', 'auto').css('z-index', 'auto');
    $('.navbar-toolbar').css('background', '');
    $('.headertop').css('background', '');
    $('.navbar-main.mainmenu').css('background', '');
    $('.navbar-nav.footer-sticky').hide();
  }
});

$( window ).resize(function() {
  if ($(window).width() >= 751 && $(window).width() <= 1300) {
    $('.dropdown').each(function(){
      var left = $(this).parent('li').position().left;
      if($(this).hasClass('one')){
        $(this).css('left', '-'+(left-10)+'px');  
      }
    });
  } else {
    $('.dropdown').each(function(){
      if($(this).hasClass('one') || jQuery(this).hasClass('two')){
        $(this).css('left', '0px');
      }
    }); 
  }
  if($(window).width() >= 768){
   	var mainimg = parseFloat($('.marketing-main').css('height'));
    mainimg = (mainimg - 20) / 2;
    $('.marketing-small').css('height', mainimg+'px');
  }
});

function detectswipe(el,func) {
  var direc = "";
  ele = document.getElementById(el);
  ele.addEventListener('touchstart',function(e){
    direc = "";
    if(typeof func == 'function') func(el,direc);
  },false);  
}

function menu_overlay_body_swipe(el,d) {
  if($(window).width() < 768 && $('#navbar-collapse').hasClass('in')){
    $('.in .menu-overlay-body').trigger('click');
  }
}
function menu_overlay_body_swipe_right(el,d) {
  if($(window).width() < 768 && $('#navbar-collapse-cart').hasClass('in')){
    $('.in .menu-overlay-body').trigger('click');
  }
}

$(document).ready(function(){
  detectswipe('menu-overlay-body-swipe', menu_overlay_body_swipe);
  detectswipe('menu-overlay-body-swipe-right', menu_overlay_body_swipe_right);
  
  $('.marketing-main').load(function() { 
    if($(window).width() >= 768){
      var mainimg = parseFloat($('.marketing-main').css('height'));
      mainimg = (mainimg - 20) / 2;
      $('.marketing-small').css('height', mainimg+'px');
    }
  });
  $('.when-menu-is-stick').css('height', $('.sticky-menu-header').css('height'));
  $( ".firstprodimage" ).mouseenter(function() {
    if ($(window).width() > 1024) {
      
        $(this).children('.firstimage').animate({
          left: "-200%"
        }, 0, function() {});
        $(this).children('.secondimage').animate({
          right: "0"
        }, 0, function() {});
      
    }
  }).mouseleave(function() {
    if ($(window).width() > 1024) {
      
        $(this).children('.firstimage').animate({
          left: "0"
        }, 0, function() {});
        $(this).children('.secondimage').animate({
          right: "-200%"
        }, 0, function() {});
      
    }
  });
  if ($(window).width() >= 751 && $(window).width() <= 1300) {
    $('.dropdown').each(function(){
      var left = $(this).parent('li').position().left;
      if($(this).hasClass('one')){
        $(this).css('left', '-'+(left-10)+'px');  
      }
    });
  } else {
    $('.dropdown').each(function(){
      if($(this).hasClass('one') || $(this).hasClass('two')){
        $(this).css('left', '0px');
      }
    }); 
  }
  $('.toggle').click(function() {
    if ($(window).width() <= 960) { 
      var $toggle = $(this);
      if($toggle.next('ul').is(':visible')) {
        $toggle.next('ul').hide();
        $toggle.children('span').html('<i class="fa fa-angle-down"></i>');
      } else {
        $toggle.next('ul').show();
        $toggle.children('span').html('<i class="fa fa-angle-up"></i>');
      }
    }
  });
  Shopify.getCart(function(e) {
    var cart = e;
    var cart_summary = $('#cart-popup');
    jQuery(".cart-current-items").html(cart.item_count);
    if (cart_summary.length) {
      cart_summary.empty();
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          var $html = '';
          if (value.length) {
            $html += '<div class="container">';
            $html += '<form action="/cart" method="post">';
            $html += '<ul class="cart-popup-ul-top">';
            $html += '<li class="total-items"><b>Total : </b><span class="cart-current-items">'+cart.item_count+'</span> Items</li>';
            $html += '<li class="total-price">'+ Shopify.formatMoney(cart.total_price, window.money_format) +'</li>';
            $html += '</ul>';
            $html += '<ul class="cart-popup-ul-middle">';
            jQuery.each(value, function(i, item) {
              $html += '<li>';
              $html += '<a href="'+ item.url +'">';
              $html += '<div class="cart-img-div">';
              $html += '<img src="'+ Shopify.resizeImage(item.image, 'small') +'" alt="Image of '+ item.title +'" class="cart-item-image" />';
              $html += '<span class="pop-qty-crat">'+ item.quantity +'</span>';
              $html += '</div>';
              $html += '<div class="cart-item-info">';
              $html += '<span class="cart-item-title">'+ item.title +'</span>';
              $html += '<p class="cart-item-price">'+ Shopify.formatMoney(item.price, window.money_format) +'</p>';
              $html += '</div>';
              $html += '<a href="/cart/change?line='+(i+1)+'&quantity=0" class="removeLineCartPop" rel="'+ item.variant_id +'">x</a>';
              $html += '</a>';
              $html += '</li>';
            });
            $html += '</ul>';

            $html += '<ul class="cart-popup-ul-bottom">';
            $html += '<li><a href="/cart" class="btn btn-large btn-secondary">View My Cart</a></li>';
            $html += '<li>';
            $html += '<a href="/checkout" class="btn btn-primary btn-block buy-btn btn-lg button-with-appand-checkout">';
            $html += '<span class="bg-img">&nbsp;</span>';
            $html += '<span class="checkouttext">Secure Checkout</span>';
            $html += '</a>';
            $html += '</li>';
            $html += '</ul></form></div>';
            cart_summary.removeClass('empty-popup');
          } else {
            $html = '<div class="container"><ul class="cart-popup-ul-bottom"><li class="empty-cart-popup-msg">Your cart is empty. Did you forget to add something?</li><li><a href="/collections/all" class="btn btn-large btn-primary">Shop Now</a></li></ul></div>';
            cart_summary.addClass('empty-popup');
          }
          cart_summary.append($html);
        }
      });
    }
  });
});
$('.model-close').click(function(){
  $(this).parent('.modal-dialog').parent('.modal').find('.modal-backdrop').trigger('click');
});
$('.menu-overlay-body').click(function(e){
  if($(this).parent('div').hasClass('right') && $('#navbar-collapse-cart').hasClass('in')){
  	$('#open-right-cart').trigger('click');
  } else if($('#navbar-collapse').hasClass('in')) {
    $('.navbar-toggle').trigger('click');
  }
});
$('.continue-shopping-cart, .footer-sticky').click(function(e){
  if ($(window).width() <= 767) {
    e.preventDefault();
    $('#open-right-cart').trigger('click');
  }
});
$('.navbar-toggle').click(function(){
  if($('#navbar-collapse').hasClass('in')){
    $('.menu-overlay-body').css('display', 'none');
    $('.mm-menu').css('z-index', '9999').css('left', '0');
    setTimeout(function(){
      $('.mm-menu').css('right', '0');
      $('#navbar-collapse').removeClass('in');
    }, 400);
  } else {
    $('#navbar-collapse').addClass('in');
    $('.mm-menu').css('right', 'auto').css('left', '0').css('left', '260px');
    setTimeout(function(){
      $('.mm-menu').css('z-index', '-1');
      $('.in .menu-overlay-body').css('display', 'block');
    }, 400);
  }
});
$('#open-right-cart').click(function(e){
  e.preventDefault();
  if($('#navbar-collapse-cart').hasClass('in')){
    $('.menu-overlay-body').css('display', 'none');
    $('.mm-menu').css('z-index', '9999').css('right', '0');
    setTimeout(function(){
      $('.mm-menu').css('left', '0');
      $('#navbar-collapse-cart').removeClass('in');
      $('#cart-popup-right').css('display', 'none');
    }, 400);
  } else {
    $('#navbar-collapse-cart').addClass('in');
    $('#cart-popup-right').css('display', 'block');
    $('.mm-menu').css('left', 'auto').css('right', '0').css('right', '260px');
    setTimeout(function(){
      $('.mm-menu').css('z-index', '-1');
      $('.in .menu-overlay-body').css('display', 'block');
    }, 400);
  }
});

$('.has-sub').click(function(e){
  e.preventDefault();
  $(".mobile-menu").css('position', 'absolute');
  var id = $(this).children('.opne-sub').attr('href');
  $(id).css('display', 'block');
  $(this).parent('ul').css('left', '-100%').css('display', 'none');
  $(id).animate({
    left: "0"
  }, 4, function() {
    $(id).css('position', 'relative').css('display', 'block');
  });
});
$('.opne-parent').click(function(e){
  e.preventDefault();
  $(".mobile-menu").css('position', 'absolute');
  var id = $(this).attr('href');
  $(id).css('display', 'block');
  $(this).parent('li').parent('ul').css('left', '100%').css('display', 'none');
  $(id).animate({
    left: "0"
  }, 4, function() {
    $(id).css('position', 'relative').css('display', 'block');
  });
});
function get_value_selected_swatch(idp){
  var option0 = "";
  var option1 = "";
  var option2 = "";
  var selImage = -1;
  option0 = $('.option0-'+idp).find('ul').find('.selected').attr('data-id');
  option1 = $('.option1-'+idp).find('ul').find('.selected').attr('data-id');
  option2 = $('.option2-'+idp).find('ul').find('.selected').attr('data-id');
  if(option0 != undefined || option1 != undefined || option2 != undefined){
    if($('#option1-'+idp).attr('data-option') != undefined && option0 == undefined){
      $('.addtocart-'+idp).attr('disabled', true);
      if($('.addtocart-'+idp).children('.addtocarttext').attr('data-change') == "1"){
      	$('.addtocart-'+idp).children('.addtocarttext').html($('#option1-'+idp).attr('data-option'));
      }
      return false;
    }
    if($('#option2-'+idp).attr('data-option') != undefined && option1 == undefined){
      $('.addtocart-'+idp).attr('disabled', true);
      if($('.addtocart-'+idp).children('.addtocarttext').attr('data-change') == "1"){
      	$('.addtocart-'+idp).children('.addtocarttext').html($('#option2-'+idp).attr('data-option'));
      }
      return false;
    }
    if($('#option3-'+idp).attr('data-option') != undefined && option2 == undefined){
      $('.addtocart-'+idp).attr('disabled', true);
      if($('.addtocart-'+idp).children('.addtocarttext').attr('data-change') == "1"){
      	$('.addtocart-'+idp).children('.addtocarttext').html($('#option3-'+idp).attr('data-option'));
      }
      return false;
    }
    var id = option0;
    if(option1 != undefined){
      id = id + "_" + option1;
    }
    if(option2 != undefined){
      id = id + "_" + option2;
    }
    if($(".product-veriant-"+idp).children("label[title='"+id+"']").attr('data-price') === undefined) {
      $('#compare_value-'+idp).html('N/A');
      $('#price_value-'+idp).html('N/A');
      $('#save_value-'+idp).html('N/A'); 
      if($('.addtocart-'+idp).children('.addtocarttext').attr('data-change') == "1"){
      	$('.addtocart-'+idp).children('.addtocarttext').html('Size/Color N/A');
      }
      $('.addtocart-'+idp).children('.bg-img').hide();
      $('.addtocart-'+idp).attr('disabled', true);
    } else {
      var price = $(".product-veriant-"+idp).children("label[title='"+id+"']").attr('data-price');
      var vId = $(".product-veriant-"+idp).children("label[title='"+id+"']").attr('id');
      var available = $(".product-veriant-"+idp).children("label[title='"+id+"']").attr('data-available');
      var save = $(".product-veriant-"+idp).children("label[title='"+id+"']").attr('data-save');
      var compareat = $(".product-veriant-"+idp).children("label[title='"+id+"']").attr('data-compareat');
      var data_image = $(".product-veriant-"+idp).children("label[title='"+id+"']").attr('data-image');
      var data_zoom_image = $(".product-veriant-"+idp).children("label[title='"+id+"']").attr('data-zoom-image');
      var bxCurrent = 0;
      $('.bxslider-'+idp+' li').each(function(){
        if(selImage === -1 && $(this).hasClass('bx-clone') === false){
          var current = $(this).find('img').attr('src');
          if(data_zoom_image === current){
            selImage = bxCurrent;
          }
          bxCurrent++;
        }
      });
      $('.bxslider-'+idp+'-quickview li').each(function(){
        if(selImage === -1 && $(this).hasClass('bx-clone') === false){
          var current = $(this).find('img').attr('data-zoom-image');
          if(data_zoom_image === current){
            selImage = bxCurrent;
          }
          bxCurrent++;
        }
      });
      if(selImage !== -1){
        $("#bx-pager-"+idp+" a[data-slide-index='"+selImage+"']").trigger('click');
        $("#bx-pager-"+idp+"-quickview a[data-slide-index='"+selImage+"']").trigger('click');
      }
      if(available == 'true'){
        $('.addtocart-'+idp).attr('disabled', false);
        vId = vId.replace("_q", "");
        $('#variant_id-'+idp).val(vId);
        $('.addtocart-'+idp).children('.addtocarttext').html('Buy It Now');
        $('.addtocart-'+idp).children('.bg-img').show();
      } else {
        $('.addtocart-'+idp).attr('disabled', true);
        if($('.addtocart-'+idp).children('.addtocarttext').attr('data-change') == "1"){
        	$('.addtocart-'+idp).children('.addtocarttext').html('Out Of Stock');
        }
        $('.addtocart-'+idp).children('.bg-img').hide();
      }
      if(price == undefined && vId == undefined && available == undefined){
        $('#compare_value-'+idp).html('N/A');
        $('#price_value-'+idp).html('N/A');
        $('#save_value-'+idp).html('N/A');
      } else {
        $('#compare_value-'+idp).html(compareat);	 
        $('#price_value-'+idp).html(price);
        $('#save_value-'+idp).html(save);
      } 
    }
  } else {
    var option00 = $('#option1-'+idp).attr('data-option');
    var option11 = $('#option2-'+idp).attr('data-option');
    var option22 = $('#option3-'+idp).attr('data-option');
    var vId = $(".product-veriant-"+idp).children("label[title='Default Title']").attr('id');
    var available = $(".product-veriant-"+idp).children("label[title='Default Title']").attr('data-available');
    if(available == 'true'){
      $('.addtocart-'+idp).attr('disabled', false);
      vId = vId.replace("_q", "");
      $('#variant_id-'+idp).val(vId);
      $('.addtocart-'+idp).children('.addtocarttext').html('Buy It Now');
      $('.addtocart-'+idp).children('.bg-img').show();
    } else {
      $('.addtocart-'+idp).attr('disabled', true);
      if(option0 == undefined){
        if($('.addtocart-'+idp).children('.addtocarttext').attr('data-change') == "1"){
        	$('.addtocart-'+idp).children('.addtocarttext').html(option00);
        }
      } else if(option1 == undefined){
        if($('.addtocart-'+idp).children('.addtocarttext').attr('data-change') == "1"){
        	$('.addtocart-'+idp).children('.addtocarttext').html(option11);
        }
      } else if(option2 == undefined){
        if($('.addtocart-'+idp).children('.addtocarttext').attr('data-change') == "1"){
        	$('.addtocart-'+idp).children('.addtocarttext').html(option22);
        }
      } 
    }
  }
}
function get_value_selected_option_select(idp, _q){
  if(_q === undefined){
  	_q ="";
  }
  var option0 = "";
  var option1 = "";
  var option2 = "";
  var selImage = -1;
  option0 = $('.option0-'+idp+_q).find('.single-option-selector1').val();
  option1 = $('.option1-'+idp+_q).find('.single-option-selector1').val();
  option2 = $('.option2-'+idp+_q).find('.single-option-selector1').val();
  if(option0 != undefined || option1 != undefined || option2 != undefined){
    if($('#option1-'+idp+_q).attr('data-option') != undefined && option0 == undefined){
      $('.addtocart-'+idp+_q).attr('disabled', true);
      if($('.addtocart-'+idp+_q).children('.addtocarttext').attr('data-change') == "1"){
      	$('.addtocart-'+idp+_q).children('.addtocarttext').html($('#option1-'+idp+_q).attr('data-option'));
      }
      return false;
    }
    if($('#option2-'+idp+_q).attr('data-option') != undefined && option1 == undefined){
      $('.addtocart-'+idp+_q).attr('disabled', true);
      if($('.addtocart-'+idp+_q).children('.addtocarttext').attr('data-change') == "1"){
      	$('.addtocart-'+idp+_q).children('.addtocarttext').html($('#option2-'+idp+_q).attr('data-option'));
      }
      return false;
    }
    if($('#option3-'+idp+_q).attr('data-option') != undefined && option2 == undefined){
      $('.addtocart-'+idp+_q).attr('disabled', true);
      if($('.addtocart-'+idp+_q).children('.addtocarttext').attr('data-change') == "1"){
      	$('.addtocart-'+idp+_q).children('.addtocarttext').html($('#option3-'+idp+_q).attr('data-option'));
      }
      return false;
    }
    var id = option0;
    if(option1 != undefined){
      id = id + "_" + option1;
    }
    if(option2 != undefined){
      id = id + "_" + option2;
    }
    if($(".product-veriant-"+idp+_q).children("label[title='"+id+"']").attr('data-price') === undefined) {
      $('#compare_value-'+idp+_q).html('N/A');
      $('#price_value-'+idp+_q).html('N/A');
      $('#save_value-'+idp+_q).html('N/A'); 
      if($('.addtocart-'+idp+_q).children('.addtocarttext').attr('data-change') == "1"){
      	$('.addtocart-'+idp+_q).children('.addtocarttext').html('Size/Color N/A');
      }
      $('.addtocart-'+idp+_q).children('.bg-img').hide();
      $('.addtocart-'+idp+_q).attr('disabled', true);
    } else {
      var price = $(".product-veriant-"+idp+_q).children("label[title='"+id+"']").attr('data-price');
      var vId = $(".product-veriant-"+idp+_q).children("label[title='"+id+"']").attr('id');
      var available = $(".product-veriant-"+idp+_q).children("label[title='"+id+"']").attr('data-available');
      var save = $(".product-veriant-"+idp+_q).children("label[title='"+id+"']").attr('data-save');
      var compareat = $(".product-veriant-"+idp+_q).children("label[title='"+id+"']").attr('data-compareat');
      var data_image = $(".product-veriant-"+idp+_q).children("label[title='"+id+"']").attr('data-image');
      var data_zoom_image = $(".product-veriant-"+idp+_q).children("label[title='"+id+"']").attr('data-zoom-image');
      var bxCurrent = 0;
      $('.bxslider-'+idp+_q+' li').each(function(){
        if(selImage === -1 && $(this).hasClass('bx-clone') === false){
          var current = $(this).find('img').attr('src');
          if(data_zoom_image === current){
            selImage = bxCurrent;
          }
          bxCurrent++;
        }
      });
      $('.bxslider-'+idp+'-quickview li').each(function(){
        if(selImage === -1 && $(this).hasClass('bx-clone') === false){
          var current = $(this).find('img').attr('data-zoom-image');
          if(data_zoom_image === current){
            selImage = bxCurrent;
          }
          bxCurrent++;
        }
      });
      if(selImage !== -1){
        $("#bx-pager-"+idp+_q+" a[data-slide-index='"+selImage+"']").trigger('click');
        $("#bx-pager-"+idp+"-quickview a[data-slide-index='"+selImage+"']").trigger('click');
      }
      if(available == 'true'){
        $('.addtocart-'+idp+_q).attr('disabled', false);
        vId = vId.replace("_q", "");
        $('#variant_id-'+idp+_q).val(vId);
        $('.addtocart-'+idp+_q).children('.addtocarttext').html('Buy It Now');
        $('.addtocart-'+idp+_q).children('.bg-img').show();
      } else {
        $('.addtocart-'+idp+_q).attr('disabled', true);
        if($('.addtocart-'+idp+_q).children('.addtocarttext').attr('data-change') == "1"){
        	$('.addtocart-'+idp+_q).children('.addtocarttext').html('Out Of Stock');
        }
        $('.addtocart-'+idp).children('.bg-img').hide();
      }
      if(price == undefined && vId == undefined && available == undefined){
        $('#compare_value-'+idp+_q).html('N/A');
        $('#price_value-'+idp+_q).html('N/A');
        $('#save_value-'+idp+_q).html('N/A');
      } else {
        $('#compare_value-'+idp+_q).html(compareat);	 
        $('#price_value-'+idp+_q).html(price);
        $('#save_value-'+idp+_q).html(save);
      } 
    }
  } else {
    var option00 = $('#option1-'+idp+_q).attr('data-option');
    var option11 = $('#option2-'+idp+_q).attr('data-option');
    var option22 = $('#option3-'+idp+_q).attr('data-option');
    var vId = $(".product-veriant-"+idp+_q).children("label[title='Default Title']").attr('id');
    var available = $(".product-veriant-"+idp+_q).children("label[title='Default Title']").attr('data-available');
    if(available == 'true'){
      $('.addtocart-'+idp+_q).attr('disabled', false);
      vId = vId.replace("_q", "");
      $('#variant_id-'+idp+_q).val(vId);
      $('.addtocart-'+idp+_q).children('.addtocarttext').html('Buy It Now');
      $('.addtocart-'+idp+_q).children('.bg-img').show();
    } else {
      $('.addtocart-'+idp+_q).attr('disabled', true);
      if(option0 == undefined){
        if($('.addtocart-'+idp+_q).children('.addtocarttext').attr('data-change') == "1"){
        	$('.addtocart-'+idp+_q).children('.addtocarttext').html(option00);
        }
      } else if(option1 == undefined){
        if($('.addtocart-'+idp+_q).children('.addtocarttext').attr('data-change') == "1"){
        	$('.addtocart-'+idp+_q).children('.addtocarttext').html(option11);
        }
      } else if(option2 == undefined){
        if($('.addtocart-'+idp+_q).children('.addtocarttext').attr('data-change') == "1"){
        	$('.addtocart-'+idp+_q).children('.addtocarttext').html(option22);
        }
      } 
    }
  }
}
$('.close_sizing_model').click(function(){
  $(this).parent('.modal-footer').parent('.modal-content').parent('.modal-dialog').parent('.modal').children('.modal-backdrop').trigger('click');
});
$('#cartAddPopup').click(function(e){
  e.preventDefault();
  window.location.href = "/cart";  
});
$('.cart-poplink').on('mouseenter', function(e) {
  if ($(window).width() > 767) {
    $("#cartAddPopup").animate({
      top: "-200px"
    }, 500, function() {
      $("#cartAddPopup").css('visibility', 'hidden');
    });
  }
});
$('.addCart-popup-close').on('click', function(e) {
  $("#cartAddPopup").animate({
    top: "-200px"
  }, 500, function() {
    $("#cartAddPopup").css('visibility', 'hidden');
  });
});

$('.btn-addcart-div-click').on('click', function(e) {
  if ($(this).children('.addtocart').attr('disabled') === 'disabled') {
    alert('Select options');
  } else {
    if($(this).children('.addtocart').hasClass('addtocart-ajax')){
      var flag_addcart = true;
      $('.product_properties').each(function(){
      	var val = $(this).find('input').val();
        var val_charlimit = $(this).find('input').data('charlimit');
        if(val == "") {
          flag_addcart = false;
          $(this).find('input').addClass("ui-state-error");
        } else {
          $(this).find('input').removeClass("ui-state-error");
          $(this).find('.error-limit').hide();
          if(val_charlimit != undefined) {
          	if(val.length > val_charlimit){
              flag_addcart = false;
              $(this).find('input').addClass("ui-state-error");
              $(this).find('.error-limit').html("Oops, we won't have space to print all that, try something shorter.").show();
            }
          }
        }
      });
      if(flag_addcart) {
        var o = $(this).parent("form");
        if (0 == o.serialize().length) {
          //alert('Select options'); 
        } else {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            async: !0,
            data: o.serialize(),
            dataType: "json",
            beforeSend: function() {
              $("body").addClass("is_loading");
              $('.addtocart-ajax').attr('disabled', true);
            },
            error: function(t) {
              $("body").removeClass("is_loading");
              $('.addtocart-ajax').children('.addtocarttext').html('Buy It Now');
              $('.addtocart-ajax').attr('disabled', false);
            },
            success: function(t) {
              
              Shopify.getCart(function(e) {
                var cart_current = jQuery(".cart-current-items").html();
                cart_current = parseInt(cart_current);
                var i = parseInt(o.find('select[name="quantity"]').val()), r = "#cartAddPopup", a = jQuery(r);
                cart_current = cart_current + i;
                jQuery(".cart-current-items").html(cart_current);
                var img = '<a href="'+t.url+'"><img src="'+Shopify.resizeImage(t.image, "small")+'" alt="'+t.product_title+'" /></a>';
                a.find('.addCart-product-item-img').html(img);
                var html = '';
                if(t.product_title != ""){
                  html += '<p clas="title"><a href="'+t.url+'"><b>'+t.product_title+'</b></a></p>'; 
                }
                if(t.variant_title != "" && t.variant_title != null){
                  html += '<p clas="option1"><b>'+t.variant_title+'</b></p>'; 
                }
                html += '<p class="addCart-product-qty"><b>Quantity:</b> '+i+'</p>';
                a.find('.addCart-product-details').html(html);
                a.find(".addCart-product-item-price").html(Shopify.formatMoney(t.price * i, window.money_format));
                $("body").removeClass("is_loading");
                $('.addtocart-ajax').children('.addtocarttext').html('Buy It Now');
                $('.addtocart-ajax').attr('disabled', false);
                if ($(window).width() > 767) {
                  if ($(window).width() >= 420) {
                    a.css('width', '400px');  
                  } else {
                    a.css('width', '300px');     
                  }
                  a.css('visibility', 'visible');
                  var scroll = $(window).scrollTop() + 165;
                  a.animate({
                    top: scroll+"px"
                  }, 500);
                  setTimeout(function(){
                    a.animate({
                      top: "-200px"
                    }, 500, function() {
                      jQuery("#cartAddPopup").css('visibility', 'hidden');
                    });
                  }, 5000);
                } else {
                  $('#open-right-cart').trigger('click');
                }
                var cart = e;
                var cart_summary = $('#cart-popup');
                if (cart_summary.length) {
                  cart_summary.empty();
                  jQuery.each(cart, function(key, value) {
                    if (key === 'items') {
                      var $html = '';
                      var $html1 = '';
                      if (value.length) {
                        $html += '<div class="container">';
                        $html += '<form action="/cart" method="post">';
                        $html += '<ul class="cart-popup-ul-top">';
                        $html += '<li class="total-items"><b>Total : </b><span class="cart-current-items">'+cart.item_count+'</span> Items</li>';
                        $html += '<li class="total-price">'+ Shopify.formatMoney(cart.total_price, window.money_format) +'</li>';
                        $html += '</ul>';
                        $html += '<ul class="cart-popup-ul-middle">';
                        jQuery.each(value, function(i, item) {
                          $html += '<li>';
                          $html += '<a href="'+ item.url +'">';
                          $html += '<div class="cart-img-div">';
                          $html += '<img src="'+ Shopify.resizeImage(item.image, 'small') +'" alt="Image of '+ item.title +'" class="cart-item-image" />';
                          $html += '<span class="pop-qty-crat">'+ item.quantity +'</span>';
                          $html += '</div>';
                          $html += '<div class="cart-item-info">';
                          $html += '<span class="cart-item-title">'+ item.title +'</span>';
                          $html += '<p class="cart-item-price">'+ Shopify.formatMoney(item.price, window.money_format) +'</p>';
                          $html += '</div>';
                          $html += '<a href="/cart/change?line='+(i+1)+'&quantity=0" class="removeLineCartPop" rel="'+ item.variant_id +'">x</a>';
                          $html += '</a>';
                          $html += '</li>';

                          $html1 += '<li>';
                          $html1 += '<a href="'+ item.url +'">';
                          $html1 += '<div class="cart-img-div">';
                          $html1 += '<img src="'+ Shopify.resizeImage(item.image, 'small') +'" alt="Image of '+ item.title +'" class="cart-item-image" />';
                          $html1 += '<span class="pop-qty-crat">'+ item.quantity +'</span>';
                          $html1 += '</div>';
                          $html1 += '<div class="cart-item-info">';
                          $html1 += '<span class="cart-item-title">'+ item.title +'</span>';
                          $html1 += '<p class="cart-item-price">'+ Shopify.formatMoney(item.price, window.money_format) +'</p>';
                          $html1 += '</div>';
                          $html1 += '<a href="/cart/change?line='+(i+1)+'&quantity=0" class="removeLineCartPop" rel="'+ item.variant_id +'">x</a>';
                          $html1 += '</a>';
                          $html1 += '</li>';
                        });
                        $html += '</ul>';

                        $html += '<ul class="cart-popup-ul-bottom">';
                        $html += '<li><a href="/cart" class="btn btn-large btn-secondary">View My Cart</a></li>';
                        $html += '<li>';
                        $html += '<a href="/checkout" class="btn btn-primary btn-block buy-btn btn-lg button-with-appand-checkout">';
                        $html += '<span class="bg-img">&nbsp;</span>';
                        $html += '<span class="checkouttext">Secure Checkout</span>';
                        $html += '</a>';
                        $html += '</li>';
                        $html += '</ul></form></div>';
                        cart_summary.removeClass('empty-popup');
                      } else {
                        $html = '<div class="container"><ul class="cart-popup-ul-bottom"><li class="empty-cart-popup-msg">Your cart is empty. Did you forget to add something?</li><li><a href="/collections/all" class="btn btn-large btn-primary">Shop Now</a></li></ul></div>';
                        cart_summary.addClass('empty-popup');
                      }
                      cart_summary.append($html);
                      $("#cart-popup-right .cart-popup-ul-middle").html($html1);
                      $("#cart-popup-right .total-price").html(Shopify.formatMoney(cart.total_price, window.money_format));
                    }
                  });
                }

              });
            }
          }); 
        }
      }
    }
  }
});